import { chain,UpdateCart,LoadCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateShipTo";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import {
    makeHandlerChainAwaitable,
} from "@insite/client-framework/HandlerCreator";
import { updateCart as updateCartApi } from "@insite/client-framework/Services/CartService";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

replaceInChain(chain,
    UpdateCart,
    async props => {
    if (props.apiResult) {
        const state = props.getState();
        const location = getLocation(state);
        const parsedQuery = parseQueryString<{ cartId: string }>(location?.search?.split("?")[1] ?? "");
        const orderApprovalcartId = parsedQuery.cartId;
        
        const cartId = orderApprovalcartId ? orderApprovalcartId : state.pages.checkoutShipping.cartId;
        
        const cart = cartId ? getCartState(state, cartId).value! : getCurrentCartState(state).value!;
        await updateCartApi({
            cart: {
                ...cart,
                shipToId: props.apiResult.id,
            },
        });
    }
    },
 );
 replaceInChain(chain,
    LoadCart,
    async props => {
        const state = props.getState();
        const location = getLocation(state);
        const parsedQuery = parseQueryString<{ cartId: string }>(location?.search?.split("?")[1] ?? "");
        const orderApprovalcartId = parsedQuery.cartId;
        
        const cartId = orderApprovalcartId ? orderApprovalcartId : state.pages.checkoutShipping.cartId;
        
        if (cartId) {
            props.dispatch(loadCart({ cartId }));
        } else {
            await makeHandlerChainAwaitable(loadCurrentCart)({ getPromotions: true })(props.dispatch, props.getState);
        }
    },
 );